import Vue from 'vue'
import store from './store'
import router from '@/router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken} from '@/utils/auth' // getToken from cookie
import { routeWhiteList } from './utils/common'
/**
 * 路由拦截判断token及权限   customized 为监测因素内的路由，所以都是白名单
 */
router.beforeEach((to, from, next) => {
    store.state.loadding2 = true
    NProgress.start()
    // next()
    if (getToken()) {
        if (to.path === '/login'||(to.path === '/401')) {
            next()
            store.state.loadding2 = false
            NProgress.done()
        } else{
            let permissionObj = store.state.permission.routerKeyData[to.path]
            let hasPermission = permissionObj?permissionObj.hasPromiss:true;
            
            if (hasPermission||routeWhiteList.findIndex(item=>to.path.includes(item)) !== -1) {
                next()
            } else {
                next({
                    path: '/401',
                    query: {redirect: to.path}  // 将跳转的路由name作为参数，展示模块
                })
            }
        }
    }else{
        if (routeWhiteList.findIndex(item=>to.path.includes(item))!=-1) {
            next()
        }else{
            next('/login') // 否则全部重定向到登录页
            NProgress.done()
        }
    }
})

router.afterEach((to, from) => {
    store.state.loadding2 = false
    NProgress.done()
})